import { Folder, File } from 'interface/lessons-management/LessonsBase.interface'

export const isFolderType = (type: File | Folder): type is Folder => {
	return (type as Folder)?.children !== undefined
}